import { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Stack } from '@mui/material';
import { useForm } from 'react-hook-form';
import { FormProvider } from 'src/components/atoms/hook-form';
import { LoadingButton } from '@mui/lab';
import { BiErrorCircle } from 'react-icons/bi';

export const CancelButton = ({ onSubmit, isSubmitting, ...props }: any) => {
  const [deleteMdl, setDeleteMdl] = useState(false);
  const methods = useForm();

  const onSubmitWithModalClose = async (data: any) => {
    await onSubmit(data);
    setDeleteMdl(false);
  };

  return (
    <>
      <Button
        {...props}
        variant="contained"
        color="error"
        onClick={() => setDeleteMdl(true)}
        sx={{
          height: 50,
          textTransform: 'none',
          ...props.sx,
        }}
      >
        予約をキャンセルする
      </Button>

      <Dialog open={deleteMdl} onClose={() => setDeleteMdl(false)}>
        <FormProvider methods={methods} onSubmit={methods.handleSubmit(onSubmitWithModalClose)}>
          <Stack spacing={4} sx={{ py: 6, px: 4, alignItems: 'center' }}>
            <BiErrorCircle size={70} color="#d32f2f" />
            <DialogTitle sx={{ p: 0, fontWeight: 'bold' }}>本当にキャンセルしますか？</DialogTitle>
            <DialogContent sx={{ p: 0 }}>
              <DialogContentText>キャンセルの取り消しはできません</DialogContentText>
            </DialogContent>
            <DialogActions sx={{ width: '100%', justifyContent: 'center', gap: 2, pt: 2 }}>
              <Button variant="outlined" onClick={() => setDeleteMdl(false)}>
                戻る
              </Button>
              <LoadingButton variant="contained" color="error" type="submit" loading={isSubmitting}>
                キャンセル
              </LoadingButton>
            </DialogActions>
          </Stack>
        </FormProvider>
      </Dialog>
    </>
  );
};
